/**
 * Types pour les décisions SAV V2
 */

import { ISavV2Quote } from './savV2Quote';

export enum DecisionType {
  ACCORD = 'ACCORD',
  PARTIAL = 'PARTIAL',
  REFUSAL = 'REFUSAL',
}

export enum DecisionStatus {
  DRAFT = 'DRAFT',
  SENT_TO_GARANT = 'SENT_TO_GARANT', // En attente de validation garant OU signature garant en cours
  ACCEPTED = 'ACCEPTED', // Legacy v1 - gardé pour compatibilité
  REFUSED = 'REFUSED', // Legacy v1 - gardé pour compatibilité
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED',

  // Nouveaux statuts pour le workflow v2 signature
  /** @deprecated Ne plus utiliser - On reste en SENT_TO_GARANT jusqu'à signature effective */
  GARANT_VALIDATED = 'GARANT_VALIDATED',
  GARANT_REFUSED = 'GARANT_REFUSED', // Garant a refusé
  /** @deprecated Ne plus utiliser - On reste en SENT_TO_GARANT jusqu'à signature effective */
  PENDING_GARANT_SIGNATURE = 'PENDING_GARANT_SIGNATURE',
  PENDING_BENEFICIARY_SIGNATURE = 'PENDING_BENEFICIARY_SIGNATURE', // Garant a signé, en attente bénéficiaire
  SIGNED = 'SIGNED', // Toutes signatures complétées
}

export interface DecisionData {
  // Lignes couvertes (seulement les modifications par rapport au devis)
  coveredLines?: {
    lineIndex: number;
    coveredAmount: number;
    commercialAmount?: number;
  }[];

  // Montants totaux (pour performance/cache)
  totalAmount?: number;
  coveredAmount?: number;
  uncoveredAmount?: number;
  totalCommercialAmount?: number; // Total des gestes commerciaux

  // Explications
  explanationBeneficiary?: string;
  explanationGarant?: string;
  explanationRepairer?: string;

  // Raison de refus
  refusalReason?: string;
}

export interface GarantValidation {
  sentAt?: string;
  sentBy?: string;
  decision?: 'accepted' | 'refused';
  reason?: string;
  decidedAt?: string;
  decidedBy?: string;
  byMandate?: boolean;
}

export interface SignaturePerson {
  // Identité
  name: string;
  email: string;
  phone?: string;
  
  // Signature
  signatureId: string;      // ID YouSign du signataire
  signatureLink?: string;    // Lien de signature
  signedAt?: string;
  signedBy: string;          // Email ou nom de celui qui a signé
  
  // Métadonnées
  ipAddress?: string;
  documentId?: number;       // Document signé individuel
  messageId?: string;        // ID du message envoyé
}

export interface Signatures {
  // Méthode de signature
  method?: 'electronic' | 'manual';
  
  // YouSign
  youSignRequestId?: string;
  
  // Signataires
  garant?: SignaturePerson;
  beneficiary?: SignaturePerson;
  
  // Document final
  signedDocumentId?: number;
  signedDocumentUrl?: string;
  completedAt?: string;
  
  // Gestion d'erreur
  error?: string;
}

export interface ISavV2Decision {
  id: string;
  interventionId: string;
  quoteId: string;
  decisionType: DecisionType;
  decisionData?: DecisionData | null;
  garantValidation?: GarantValidation | null;
  signatures?: Signatures | null;
  status: DecisionStatus;
  cancelledReason?: string;
  createdAt: string;
  createdBy?: string;
  updatedAt?: string;
  cancelledAt?: string;
  cancelledBy?: string;
  pdfDocumentId?: number;
  submittedAt?: string;
  submissionMessageId?: number;
  deletedAt?: string;
  deletedBy?: string;
  deletedReason?: string;

  // Relations
  quote?: ISavV2Quote;
  submissionMessage?: any; // Type Message si besoin
}